import PayoutMethods from "components/PayoutManagement/PayoutMethods";

const PayoutManagement = () => {
  return (
    <div className="">
      <PayoutMethods />
    </div>
  );
};

export default PayoutManagement;
